import React, {useCallback, useEffect, useState} from 'react';
import {Modal} from "../../index";
import eventBus from "../../../service/eventBus";
import {ModalEvents} from "./ModalEvents";

export const ModalContainer = () => {
  const modalRef = React.useRef();
  const contentRef = React.useRef();
  const titleRef = React.useRef();
  const propsRef = React.useRef();
  const onCloseRef = React.useRef();
  const [, forceUpdate] = useState(0);

  const openFn = useCallback(({detail: {content, title, onClose, ...props}}) => {
    propsRef.current = props;
    contentRef.current = content;
    titleRef.current = title;
    onCloseRef.current = onClose;
    forceUpdate(c => c + 1);
    modalRef?.current?.open();
  }, [forceUpdate]);

  const closeFn = useCallback(() => {
    propsRef.current = null;
    contentRef.current = null;
    titleRef.current = null;
    onCloseRef.current = null;
    forceUpdate(0);
    modalRef?.current?.close();
  }, [forceUpdate]);

  useEffect(() => {
    eventBus.on(ModalEvents.OPEN, openFn);
    eventBus.on(ModalEvents.CLOSE, closeFn);

    return () => {
      eventBus.remove(ModalEvents.OPEN, openFn);
      eventBus.remove(ModalEvents.CLOSE, closeFn);
    };
  }, []);

  return (
    <Modal ref={modalRef} title={titleRef.current} onClose={onCloseRef.current} {...(propsRef.current || {})}>
      {contentRef.current}
    </Modal>
  );
};

export default React.memo(ModalContainer);
